import UserAppInstances from '@/components/userApp/userAppInstances';
import { Box } from '@mui/material';

type Props = { maxHeight: number };
const MyUserAppInstances = ({ maxHeight }: Props) => {
  return (
    <Box sx={{ height: `${maxHeight}px` }}>
      <UserAppInstances />
    </Box>
  );
};

export default MyUserAppInstances;
